import { apiRequest } from 'api/apiClient';

const superUserRequest = (method, url, data, config = {}) =>
  apiRequest(method, url, data, {
    ...config,
    params: { ...config.params, super: true },
  });

export default superUserRequest;
